import React from 'react';
import Spinner from '@atlaskit/spinner';
function getIconSpacing(spacing) {
  switch (spacing) {
    case 'compact':
      return 'small';
    default:
      return 'medium';
  }
}
function getSpinnerAppearance({
  appearance,
  isDisabled,
  isSelected
}) {
  if (isDisabled || isSelected) {
    return 'inherit';
  }
  if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') {
    return 'invert';
  }
  return 'inherit';
}
export default function renderLoadingOverlay({
  appearance,
  spacing,
  isDisabled,
  isSelected,
  testId
}) {
  return /*#__PURE__*/React.createElement(Spinner, {
    size: getIconSpacing(spacing),
    appearance: getSpinnerAppearance({
      appearance,
      isDisabled,
      isSelected
    }),
    testId: testId ? `${testId}--loading-spinner` : undefined
  });
}